module.exports = require("lodash.uniqueid");